export default String.raw`
$(window).on('resize', function() {
    if (window.innerWidth > 767) {
        $('.footer-section-content-js').css('display', 'block');
        $('.footer-section-arrow-js').removeClass('rotate');
    } else {
        $('.footer-section-content-js').css('display', 'none');
        $('.footer-section-arrow-js').removeClass('rotate');
    }
});

$('body').on('click', '.footer-section-title-js', function(e) {
    if (window.innerWidth < 768) {
        $(e.currentTarget).parent().find('.footer-section-content-js').toggle(500);
        $(e.currentTarget).parent().find('.footer-section-arrow-js').toggleClass('rotate');
    }
});

$('body').on('click', '.scroll-top-js', function (e) {
    e.preventDefault();

    const headerHeight = $('.header-js').outerHeight();
    $('html, body').animate({ scrollTop: headerHeight }, 'slow');
});
`